module.exports = __webpack_public_path__ + "mouton.png?a12025b9e0851bd00831dcb0950242e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mouton.png
// module id = 151
// module chunks = 0